window.config = require('./config-zuerich');
window.viewmode = "zuerich";

import './table.js';
